<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi" id="dedi"><a id="page_v"></a><em>This is dedicated to<br/>Mathew Christopher Ford.</em><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedi.vue?67e69f14